import { reportEvent } from '../sensor';

type MiniappWebviewRoute = 'editing-embed' | 'mini-live';

const reportedRoutes = new Set<MiniappWebviewRoute>();

/** Reports the first browser media-permission request made by a miniapp WebView page. */
export const reportMiniappWebviewPermissionRequest = (route: MiniappWebviewRoute): void => {
  if (reportedRoutes.has(route)) return;

  reportedRoutes.add(route);
  reportEvent('miniapp_webview_permission_request', {
    route,
    navigation_to_permission_request_ms: Math.round(performance.now()),
  });
};
